import React, { forwardRef, useEffect } from 'react';

import { getUID } from '@atlas/core';
import { BasePopup } from '@atlas/ui';

import { useNotificationsUIContext } from 'common/Popup/NotificationsUIContext';

export const NotificationEmitterBasePopup = forwardRef((props, ref) => {
  const { children } = props;
  const { emitPopupToggle } = useNotificationsUIContext();

  useEffect(() => {
    const popupId = getUID();

    emitPopupToggle(popupId);

    return () => {
      emitPopupToggle(popupId);
    };
  }, []);

  return (
    <BasePopup {...props} ref={ref}>
      {children}
    </BasePopup>
  );
});
